import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { ToastContainer } from "react-toastify"

import App from "./App"
import "./assets/scss/bootstrap.scss"
import * as serviceWorker from "./serviceWorker"
import store from "./store"

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
      <ToastContainer style={{ position: "absolute" }} autoClose={5000} />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root"),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
